module.exports = __webpack_public_path__ + "cb08894b978f40032d517355ded36730.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/banner/b-news.png
// module id = 7D7v
// module chunks = 4 5